import { render } from "./FaultPage.vue?vue&type=template&id=91f4023a&scoped=true"
import script from "./FaultPage.vue?vue&type=script&lang=js"
export * from "./FaultPage.vue?vue&type=script&lang=js"

import "./FaultPage.vue?vue&type=style&index=0&id=91f4023a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f4023a"],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/FaultPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91f4023a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91f4023a', __exports__)) {
    api.reload('91f4023a', __exports__)
  }
  
  module.hot.accept("./FaultPage.vue?vue&type=template&id=91f4023a&scoped=true", () => {
    api.rerender('91f4023a', render)
  })

}


export default __exports__